"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoreDataSecurityApplicationsByIdSlice = void 0;
const name_1 = require("./name.js");
const data_security_1 = require("../../../../api/data-security/index.js");
const actions_1 = require("../_idMap/actions.js");
const xuder_1 = require("@sonar-software/xuder");
exports.getCoreDataSecurityApplicationsByIdSlice = (0, xuder_1.createGetAsyncSlice)({
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request, response) => (0, actions_1.updateApplicationReferences)([
                Object.assign(Object.assign({}, response), { applicationId: request.applicationId })
            ])
        ]
    },
    name: name_1.CoreDataSecurityApplicationsByIdName,
    receive: true,
    request: true,
    requestHandler: data_security_1.getDataSecurityApplicationById,
    retainDataOnRequest: true,
    yieldType: xuder_1.SagaYieldType.Every
});
//# sourceMappingURL=get.js.map